import { useEffect, useRef } from 'react'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import styles from './SubmittedDialog.module.scss'

const SubmittedDialog = ({ hotelName }) => {
  const inputRef = useRef()

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.select()
      document.execCommand('copy')
    }
  }, [inputRef])

  return (
    <ConfirmationDialog
      title={`${hotelName} added!`}
      positiveMessage="Back to dashboard"
      confirmLink="/"
      closeLink="/"
    >
      <div className={styles.container}>
        <p>{hotelName} added to the system succesfully.</p>
        {/* <p>
          Login link created and sent to {firstName} {lastName}
        </p> */}
        {/* <div className={styles.status}>
          <div className={styles.row}>
            <EmailedIcon />
            <span>
              Emailed to{' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`mailto:${email}?subject=Directful login&body=Use this link to login to dashboard: ${link}`}
              >
                {email}
              </a>
            </span>
          </div>
          <div className={styles.row}>
            <TextedIcon />
            <span>
              Texted to <strong>{phone}</strong>
            </span>
          </div>
        </div>
        <div className={styles.linkInputContainer}>
          <TextInput
            forwardedRef={inputRef}
            className={styles.linkInput}
            value={link}
            label="Link to share"
          />
          <div className={styles.copied}>Copied!</div>
        </div> */}
      </div>
    </ConfirmationDialog>
  )
}

SubmittedDialog.defaultProps = {
  hotelName: 'Kailani Resorts New York',
  firstName: 'John',
  lastName: 'Doe',
  email: 'john@kailani.com',
  phone: '(555) 555-55-55'
}

export default SubmittedDialog
